import React from 'react'
import { QualificationStatus } from '../../types'

export interface QualificationStatusBadgeProps {
  status: 'pendiente' | 'califica' | 'no_califica'
  size?: 'small' | 'medium' | 'large'
  showText?: boolean
  className?: string
}

const QualificationStatusBadge: React.FC<QualificationStatusBadgeProps> = ({
  status,
  size = 'medium',
  showText = true,
  className = '',
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case QualificationStatus.CALIFICA:
        return {
          text: 'Califica',
          bgColor: 'bg-green-100',
          textColor: 'text-green-800',
          borderColor: 'border-green-200',
        }
      case QualificationStatus.NO_CALIFICA:
        return {
          text: 'No Califica',
          bgColor: 'bg-red-100',
          textColor: 'text-red-800',
          borderColor: 'border-red-200',
        }
      case QualificationStatus.PENDIENTE:
      default:
        return {
          text: 'Pendiente de Calificación',
          bgColor: 'bg-gray-100',
          textColor: 'text-gray-800',
          borderColor: 'border-gray-200',
        }
    }
  }

  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'px-2 py-1 text-xs'
      case 'large':
        return 'px-4 py-2 text-base'
      case 'medium':
      default:
        return 'px-3 py-1 text-sm'
    }
  }

  const config = getStatusConfig()
  const sizeClasses = getSizeClasses()

  return (
    <span
      className={`
        inline-flex items-center rounded-full border font-medium
        ${config.bgColor} ${config.textColor} ${config.borderColor}
        ${sizeClasses}
        ${className}
      `}
      data-testid={`qualification-badge-${status}`}
    >
      {showText && config.text}
    </span>
  )
}

export default QualificationStatusBadge
